<template>
    <div class="ion-page">
        <ion-header>
            <ion-toolbar class="app-toolbar">
                <ion-buttons v-slot: start>
                <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
                <ion-title>Change Password</ion-title>
                </ion-buttons>
            </ion-toolbar>
        </ion-header>
            <ion-content class="ion-padding">
            <ChangePassword />
        </ion-content>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonHeader, IonToolbar, IonButtons, IonBackButton, IonTitle, IonContent } from "@ionic/vue";
import ChangePassword from "@/components/account/ChangePassword.vue";

export default defineComponent ({
    name: 'changePassword',
    components: {
        ChangePassword, IonHeader, IonToolbar, IonButtons, IonBackButton, IonTitle, IonContent
    },
    data() {
        return {

        }
    },
    methods: {
        navigatePreviousPage() {
            this.$router.go(-1)
        }
  }
})
</script>